import inrFormat from "utils/inrFormat";

const commonData = {
  admin: "admin",
  customerRole: "Customer",
  greRole: "GRE",
  closingTeamLeadRole: "ClosingTeamLead",
  salesRole: "ClosingManager",
  sourcingTeamLeadRole: "SourcingTeamLead",
  sourcingManagerRole: "SourcingManager",
  CRM: "CRMUser",
  regionalHead: "RegionalHead",
  projectHead: "ProjectHead",
  verticalHead: "VerticalHead",
  subVerticalHead: "SubVerticalHead",
  bookingDocuments: "Booking Documents",
  towerEnableStatus: "Enable",
  towerDisableStatus: "Disable",
  carTowerName: "Car Parking",

  // statusLabels: {
  //   1: "Primary",
  //   2: "Secondary",
  //   3: "Tertiary",
  //   4: "Quaternary",
  //   5: "Quinary",
  // },

  statusLabels: [
    { label: "Primary", value: 1, color: "var(--green-200)" },
    { label: "Secondary", value: 2, color: "var(--blue-200)" },
    { label: "Tertiary", value: 3, color: "var(--yellow-200)" },
    { label: "Quaternary", value: 4, color: "var(--red-200)" },
    { label: "Quinary", value: 5, color: "var(--orange-200)" },
  ],

  relation: [
    //old relations
    // { label: "Self", value: "self" },
    // { label: "Father", value: "Father" },
    // { label: "Mother", value: "Mother" },
    // { label: "Son", value: "Son" },
    // { label: "Daughter", value: "Daughter" },
    // { label: "Brother", value: "Brother" },
    // { label: "Sister", value: "Sister" },
    // { label: "Spouse", value: "Spouse" },

    //New Relations added on 16-09-2025 shared by kritika
    { label: "Son", value: "Son" },
    { label: "Mother", value: "Mother" },
    { label: "Father", value: "Father" },
    { label: "Daughter", value: "Daughter" },
    { label: "Mother-in-law", value: "Mother-in-law" },
    { label: "Father-in-law", value: "Father-in-law" },
    { label: "Son-in-law", value: "Son-in-law" },
    { label: "Daughter-in-law", value: "Daughter-in-law" },
    { label: "Grand Mother", value: "Grand Mother" },
    { label: "Self", value: "Self" },
    { label: "2nd Child", value: "2nd Child" },
    { label: "1st Child", value: "1st Child" },
    { label: "Brother", value: "Brother" },
    { label: "Wife", value: "Wife" },
    { label: "Husband", value: "Husband" },
    { label: "Grand Father", value: "Grand Father" },
    { label: "Friend", value: "Friend" },
    { label: "Sister", value: "Sister" },
    { label: "Nephew", value: "Nephew" },

    // { label: "Other", value: "Other" },
  ],

  paymentList: [
    { label: "Online", value: "Online" },
    { label: "Cheque", value: "Cheque" },
    { label: "Demand Draft(DD)", value: "DD" },
    // { label: "Cash", value: "Cash" },
    { label: "Pos/Card Swipe", value: "Pos/Card Swipe" },
    { label: "NEFT/RTGS/IMPS", value: "NEFT/RTGS/IMPS" },
  ],

  paymentStatus: [
    { label: "Pending", value: 0 },
    { label: "Paid", value: 1 },
    { label: "Pending For Clearance", value: 2 },
    { label: "Reject", value: 3 },
    { label: "Lost", value: 4 },
    { label: "Failed", value: 5 },
    { label: "Refund", value: 8 },
  ],

  state: [
    {
      code: "AN",
      name: "Andaman and Nicobar Islands",
    },
    {
      code: "AP",
      name: "Andhra Pradesh",
    },
    {
      code: "AR",
      name: "Arunachal Pradesh",
    },
    {
      code: "AS",
      name: "Assam",
    },
    {
      code: "BR",
      name: "Bihar",
    },
    {
      code: "CG",
      name: "Chandigarh",
    },
    {
      code: "CH",
      name: "Chhattisgarh",
    },
    {
      code: "DH",
      name: "Dadra and Nagar Haveli",
    },
    {
      code: "DD",
      name: "Daman and Diu",
    },
    {
      code: "DL",
      name: "Delhi",
    },
    {
      code: "GA",
      name: "Goa",
    },
    {
      code: "GJ",
      name: "Gujarat",
    },
    {
      code: "HR",
      name: "Haryana",
    },
    {
      code: "HP",
      name: "Himachal Pradesh",
    },
    {
      code: "JK",
      name: "Jammu and Kashmir",
    },
    {
      code: "JH",
      name: "Jharkhand",
    },
    {
      code: "KA",
      name: "Karnataka",
    },
    {
      code: "KL",
      name: "Kerala",
    },
    {
      code: "LD",
      name: "Lakshadweep",
    },
    {
      code: "MP",
      name: "Madhya Pradesh",
    },
    {
      code: "MH",
      name: "Maharashtra",
    },
    {
      code: "MN",
      name: "Manipur",
    },
    {
      code: "ML",
      name: "Meghalaya",
    },
    {
      code: "MZ",
      name: "Mizoram",
    },
    {
      code: "NL",
      name: "Nagaland",
    },
    {
      code: "OR",
      name: "Odisha",
    },
    {
      code: "PY",
      name: "Puducherry",
    },
    {
      code: "PB",
      name: "Punjab",
    },
    {
      code: "RJ",
      name: "Rajasthan",
    },
    {
      code: "SK",
      name: "Sikkim",
    },
    {
      code: "TN",
      name: "Tamil Nadu",
    },
    {
      code: "TS",
      name: "Telangana",
    },
    {
      code: "TR",
      name: "Tripura",
    },
    {
      code: "UP",
      name: "Uttar Pradesh",
    },
    {
      code: "UK",
      name: "Uttarakhand",
    },
    {
      code: "WB",
      name: "West Bengal",
    },
  ],

  sfdcFieldsDataValues: {
    age_group: [
      { label: "Under 28 years", value: "Under 28 years" },
      { label: "28-35 years", value: "28-35 years" },
      { label: "36-42 years", value: "36-42 years" },
      { label: "43-50 years", value: "43-50 years" },
      { label: "50 + years", value: "50 + years" },
    ],
    annual_household_income: [
      { label: "Upto 5 lacs", value: "Upto 5 lacs" },
      { label: "6-10 Lacs", value: "6-10 Lacs" },
      { label: "11-15 Lacs", value: "11-15 Lacs" },
      { label: "16-20 Lacs", value: "16-20 Lacs" },
      { label: "21-30 Lacs", value: "21-30 Lacs" },
      { label: "31-50 Lacs", value: "31-50 Lacs" },
      { label: "51-1 Crore", value: "51-1 Crore" },
      { label: "Above 1 Crore", value: "Above 1 Crore" },
      { label: "N.A.", value: "N.A." },
    ],
    current_home_type: [
      { label: "1 RK", value: "1 RK" },
      { label: "1 BHK", value: "1 BHK" },
      { label: "2 BHK", value: "2 BHK" },
      { label: "3 BHK", value: "3 BHK" },
      { label: "4 BHK", value: "4 BHK" },
      { label: "Row House", value: "Row House" },
      { label: "Independent House", value: "Independent House" },
      { label: "N.A.", value: "N.A." },
    ],
    current_residence_type: [
      { label: "Own House", value: "Own House" },
      { label: "Family Owned", value: "Family Owned" },
      { label: "Rented House", value: "Rented House" },
      { label: "Company Owned", value: "Company Owned" },
    ],
    designation: [
      { label: "Junior Management", value: "Junior Management" },
      { label: "Middle Management", value: "Middle Management" },
      { label: "Top Management", value: "Top Management" },
      { label: "Homemaker", value: "Homemaker" },
      { label: "N.A.", value: "N.A." },
    ],
    gender: [
      { label: "Male", value: "Male" },
      { label: "Female", value: "Female" },
      { label: "Transgender", value: "Transgender" },
      { label: "Unknown", value: "Unknown" },
    ],
    highest_education_qualification: [
      { label: "MBA", value: "MBA" },
      { label: "BSC", value: "BSC" },
      { label: "BCOM", value: "BCOM" },
      { label: "BA", value: "BA" },
      { label: "MA", value: "MA" },
      { label: "MCOM", value: "MCOM" },
      { label: "Doctor", value: "Doctor" },
      { label: "Engineer", value: "Engineer" },
      { label: "MSC", value: "MSC" },
      { label: "MCA", value: "MCA" },
      { label: "BCA", value: "BCA" },
      { label: "CA", value: "CA" },
      { label: "Non-matric", value: "Non-matric" },
      { label: "SSC", value: "SSC" },
      { label: "HSC", value: "HSC" },
      { label: "Graduate", value: "Graduate" },
      { label: "Post Graduate", value: "Post Graduate" },
      { label: "PHD", value: "PHD" },
      { label: "N.A.", value: "N.A." },
    ],
    industry: [
      {
        label: "Agriculture and Allied Industries",
        value: "Agriculture and Allied Industries",
      },
      { label: "Automobiles", value: "Automobiles" },
      { label: "Aviation", value: "Aviation" },
      {
        label: "Banking & Financial Services",
        value: "Banking & Financial Services",
      },
      {
        label: "Cement",
        value: "Cement",
      },
      { label: "Consumer Durables", value: "Consumer Durables" },
      { label: "Education and Training", value: "Education and Training" },
      {
        label: "Financial Services",
        value: "Financial Services",
      },
      {
        label: "Gems and Jewellery",
        value: "Gems and Jewellery",
      },
      {
        label: "Healthcare",
        value: "Healthcare",
      },
      { label: "Infrastructure", value: "Infrastructure" },
      { label: "IT & ITeS", value: "IT & ITeS" },
      {
        label: "Manufacturing",
        value: "Manufacturing",
      },

      {
        label: "Media and Entertainment",
        value: "Media and Entertainment",
      },
      { label: "Oil and Gas", value: "Oil and Gas" },
      { label: "Pharmaceuticals", value: "Pharmaceuticals" },
      {
        label: "Real Estate",
        value: "Real Estate",
      },
      {
        label: "Retail",
        value: "Retail",
      },
      { label: "Science and Technology", value: "Science and Technology" },
      { label: "Services", value: "Services" },
      {
        label: "Telecommunications",
        value: "Telecommunications",
      },
      {
        label: "Textiles",
        value: "Textiles",
      },
      {
        label: "Tourism and Hospitality",
        value: "Tourism and Hospitality",
      },
      { label: "Auto/Auto Components;", value: "Auto/Auto Components;" },
      { label: "Engineering", value: "Engineering" },
      {
        label: "Aerospace",
        value: "Aerospace",
      },
      {
        label: "Defense",
        value: "Defense",
      },
      { label: "IT/ITeS;", value: "IT/ITeS;" },
      { label: "Medical Device", value: "Medical Device" },
      {
        label: "Food Processing",
        value: "Food Processing",
      },
      {
        label: "Warehousing & Logisctics",
        value: "Warehousing & Logisctics",
      },
      { label: "Furniture Manufacturing", value: "Furniture Manufacturing" },
      { label: "Renewable Energy", value: "Renewable Energy" },
      {
        label: "Solar Energy",
        value: "Solar Energy",
      },
      {
        label: "Other",
        value: "Other",
      },
    ],
    configuration_interested: [
      { label: "1 BHK", value: "1 BHK" },
      { label: "2 BHK", value: "2 BHK" },
      { label: "3 BHK", value: "3 BHK" },
      { label: "4 BHK", value: "4 BHK" },
      { label: "Row House / Villas", value: "Row House / Villas" },
    ],
    mailing_country: [
      { label: "Afghanistan", value: "Afghanistan" },
      { label: "Albania", value: "Albania" },
      { label: "Algeria", value: "Algeria" },
      { label: "Andorra", value: "Andorra" },
      { label: "Angola", value: "Angola" },
      { label: "Antigua and Barbuda", value: "Antigua and Barbuda" },
      { label: "Argentina", value: "Argentina" },
      { label: "Armenia", value: "Armenia" },
      { label: "Australia", value: "Australia" },
      { label: "Austria", value: "Austria" },
      { label: "Azerbaijan", value: "Azerbaijan" },
      { label: "Bahamas", value: "Bahamas" },
      { label: "Bahrain", value: "Bahrain" },
      { label: "Bangladesh", value: "Bangladesh" },
      { label: "Barbados", value: "Barbados" },
      { label: "Belarus", value: "Belarus" },
      { label: "Belgium", value: "Belgium" },
      { label: "Belize", value: "Belize" },
      { label: "Benin", value: "Benin" },
      { label: "Bhutan", value: "Bhutan" },
      { label: "Bolivia", value: "Bolivia" },
      { label: "Bosnia and Herzegovina", value: "Bosnia and Herzegovina" },
      { label: "Botswana", value: "Botswana" },
      { label: "Brazil", value: "Brazil" },
      { label: "Brunei", value: "Brunei" },
      { label: "Bulgaria", value: "Bulgaria" },
      { label: "Burkina Faso", value: "Burkina Faso" },
      { label: "Burundi", value: "Burundi" },
      { label: "Cabo Verde", value: "Cabo Verde" },
      { label: "Cambodia", value: "Cambodia" },
      { label: "Cameroon", value: "Cameroon" },
      { label: "Canada", value: "Canada" },
      { label: "Central African Republic", value: "Central African Republic" },
      { label: "Chad", value: "Chad" },
      { label: "Chile", value: "Chile" },
      { label: "China", value: "China" },
      { label: "Colombia", value: "Colombia" },
      { label: "Comoros", value: "Comoros" },
      {
        label: "Congo (Congo-Brazzaville)",
        value: "Congo (Congo-Brazzaville)",
      },
      {
        label: "Congo (Democratic Republic)",
        value: "Congo (Democratic Republic)",
      },
      { label: "Costa Rica", value: "Costa Rica" },
      { label: "Croatia", value: "Croatia" },
      { label: "Cuba", value: "Cuba" },
      { label: "Cyprus", value: "Cyprus" },
      { label: "Czech Republic", value: "Czech Republic" },
      { label: "Denmark", value: "Denmark" },
      { label: "Djibouti", value: "Djibouti" },
      { label: "Dominica", value: "Dominica" },
      { label: "Dominican Republic", value: "Dominican Republic" },
      { label: "Ecuador", value: "Ecuador" },
      { label: "Egypt", value: "Egypt" },
      { label: "El Salvador", value: "El Salvador" },
      { label: "Equatorial Guinea", value: "Equatorial Guinea" },
      { label: "Eritrea", value: "Eritrea" },
      { label: "Estonia", value: "Estonia" },
      { label: "Eswatini", value: "Eswatini" },
      { label: "Ethiopia", value: "Ethiopia" },
      { label: "Fiji", value: "Fiji" },
      { label: "Finland", value: "Finland" },
      { label: "France", value: "France" },
      { label: "Gabon", value: "Gabon" },
      { label: "Gambia", value: "Gambia" },
      { label: "Georgia", value: "Georgia" },
      { label: "Germany", value: "Germany" },
      { label: "Ghana", value: "Ghana" },
      { label: "Greece", value: "Greece" },
      { label: "Grenada", value: "Grenada" },
      { label: "Guatemala", value: "Guatemala" },
      { label: "Guinea", value: "Guinea" },
      { label: "Guinea-Bissau", value: "Guinea-Bissau" },
      { label: "Guyana", value: "Guyana" },
      { label: "Haiti", value: "Haiti" },
      { label: "Honduras", value: "Honduras" },
      { label: "Hungary", value: "Hungary" },
      { label: "Iceland", value: "Iceland" },
      { label: "India", value: "India" },
      { label: "Indonesia", value: "Indonesia" },
      { label: "Iran", value: "Iran" },
      { label: "Iraq", value: "Iraq" },
      { label: "Ireland", value: "Ireland" },
      { label: "Israel", value: "Israel" },
      { label: "Italy", value: "Italy" },
      { label: "Jamaica", value: "Jamaica" },
      { label: "Japan", value: "Japan" },
      { label: "Jordan", value: "Jordan" },
      { label: "Kazakhstan", value: "Kazakhstan" },
      { label: "Kenya", value: "Kenya" },
      { label: "Kiribati", value: "Kiribati" },
      { label: "Kuwait", value: "Kuwait" },
      { label: "Kyrgyzstan", value: "Kyrgyzstan" },
      { label: "Laos", value: "Laos" },
      { label: "Latvia", value: "Latvia" },
      { label: "Lebanon", value: "Lebanon" },
      { label: "Lesotho", value: "Lesotho" },
      { label: "Liberia", value: "Liberia" },
      { label: "Libya", value: "Libya" },
      { label: "Liechtenstein", value: "Liechtenstein" },
      { label: "Lithuania", value: "Lithuania" },
      { label: "Luxembourg", value: "Luxembourg" },
      { label: "Madagascar", value: "Madagascar" },
      { label: "Malawi", value: "Malawi" },
      { label: "Malaysia", value: "Malaysia" },
      { label: "Maldives", value: "Maldives" },
      { label: "Mali", value: "Mali" },
      { label: "Malta", value: "Malta" },
      { label: "Marshall Islands", value: "Marshall Islands" },
      { label: "Mauritania", value: "Mauritania" },
      { label: "Mauritius", value: "Mauritius" },
      { label: "Mexico", value: "Mexico" },
      { label: "Micronesia", value: "Micronesia" },
      { label: "Moldova", value: "Moldova" },
      { label: "Monaco", value: "Monaco" },
      { label: "Mongolia", value: "Mongolia" },
      { label: "Montenegro", value: "Montenegro" },
      { label: "Morocco", value: "Morocco" },
      { label: "Mozambique", value: "Mozambique" },
      { label: "Myanmar", value: "Myanmar" },
      { label: "Namibia", value: "Namibia" },
      { label: "Nauru", value: "Nauru" },
      { label: "Nepal", value: "Nepal" },
      { label: "Netherlands", value: "Netherlands" },
      { label: "New Zealand", value: "New Zealand" },
      { label: "Nicaragua", value: "Nicaragua" },
      { label: "Niger", value: "Niger" },
      { label: "Nigeria", value: "Nigeria" },
      { label: "North Korea", value: "North Korea" },
      { label: "North Macedonia", value: "North Macedonia" },
      { label: "Norway", value: "Norway" },
      { label: "Oman", value: "Oman" },
      { label: "Pakistan", value: "Pakistan" },
      { label: "Palau", value: "Palau" },
      { label: "Palestine", value: "Palestine" },
      { label: "Panama", value: "Panama" },
      { label: "Papua New Guinea", value: "Papua New Guinea" },
      { label: "Paraguay", value: "Paraguay" },
      { label: "Peru", value: "Peru" },
      { label: "Philippines", value: "Philippines" },
      { label: "Poland", value: "Poland" },
      { label: "Portugal", value: "Portugal" },
      { label: "Qatar", value: "Qatar" },
      { label: "Romania", value: "Romania" },
      { label: "Russia", value: "Russia" },
      { label: "Rwanda", value: "Rwanda" },
      { label: "Saint Kitts and Nevis", value: "Saint Kitts and Nevis" },
      { label: "Saint Lucia", value: "Saint Lucia" },
      {
        label: "Saint Vincent and the Grenadines",
        value: "Saint Vincent and the Grenadines",
      },
      { label: "Samoa", value: "Samoa" },
      { label: "San Marino", value: "San Marino" },
      { label: "Sao Tome and Principe", value: "Sao Tome and Principe" },
      { label: "Saudi Arabia", value: "Saudi Arabia" },
      { label: "Senegal", value: "Senegal" },
      { label: "Serbia", value: "Serbia" },
      { label: "Seychelles", value: "Seychelles" },
      { label: "Sierra Leone", value: "Sierra Leone" },
      { label: "Singapore", value: "Singapore" },
      { label: "Slovakia", value: "Slovakia" },
      { label: "Slovenia", value: "Slovenia" },
      { label: "Solomon Islands", value: "Solomon Islands" },
      { label: "Somalia", value: "Somalia" },
      { label: "South Africa", value: "South Africa" },
      { label: "South Korea", value: "South Korea" },
      { label: "South Sudan", value: "South Sudan" },
      { label: "Spain", value: "Spain" },
      { label: "Sri Lanka", value: "Sri Lanka" },
      { label: "Sudan", value: "Sudan" },
      { label: "Suriname", value: "Suriname" },
      { label: "Sweden", value: "Sweden" },
      { label: "Switzerland", value: "Switzerland" },
      { label: "Syria", value: "Syria" },
      { label: "Taiwan", value: "Taiwan" },
      { label: "Tajikistan", value: "Tajikistan" },
      { label: "Tanzania", value: "Tanzania" },
      { label: "Thailand", value: "Thailand" },
      { label: "Timor-Leste", value: "Timor-Leste" },
      { label: "Togo", value: "Togo" },
      { label: "Tonga", value: "Tonga" },
      { label: "Trinidad and Tobago", value: "Trinidad and Tobago" },
      { label: "Tunisia", value: "Tunisia" },
      { label: "Turkey", value: "Turkey" },
      { label: "Turkmenistan", value: "Turkmenistan" },
      { label: "Tuvalu", value: "Tuvalu" },
      { label: "Uganda", value: "Uganda" },
      { label: "Ukraine", value: "Ukraine" },
      { label: "United Arab Emirates", value: "United Arab Emirates" },
      { label: "United Kingdom", value: "United Kingdom" },
      { label: "United States", value: "United States" },
      { label: "Uruguay", value: "Uruguay" },
      { label: "Uzbekistan", value: "Uzbekistan" },
      { label: "Vanuatu", value: "Vanuatu" },
      { label: "Venezuela", value: "Venezuela" },
      { label: "Vietnam", value: "Vietnam" },
      { label: "Yemen", value: "Yemen" },
      { label: "Zambia", value: "Zambia" },
      { label: "Zimbabwe", value: "Zimbabwe" },
    ],
    mailing_state: [
      { label: "Aargau", value: "Aargau" },
      { label: "Aberdeenshire", value: "Aberdeenshire" },
      { label: "Abu Dhabi", value: "Abu Dhabi" },
      { label: "Aichi", value: "Aichi" },
      { label: "Ajman", value: "Ajman" },
      { label: "Akita", value: "Akita" },
      { label: "Alabama", value: "Alabama" },
      { label: "Alaska", value: "Alaska" },
      { label: "Alberta", value: "Alberta" },
      { label: "Al-Rayyan", value: "Al-Rayyan" },
      { label: "Al Wakra", value: "Al Wakra" },
      { label: "American Samoa", value: "American Samoa" },
      { label: "Amnat Charoen", value: "Amnat Charoen" },
      { label: "Andaman and Nicobar", value: "Andaman and Nicobar" },
      { label: "Andhra Pradesh", value: "Andhra Pradesh" },
      { label: "Anglesey", value: "Anglesey" },
      { label: "Ang Thong", value: "Ang Thong" },
      { label: "Angus/Forfarshire", value: "Angus/Forfarshire" },
      { label: "Antrim", value: "Antrim" },
      { label: "Aomori", value: "Aomori" },
      { label: "Argyllshire", value: "Argyllshire" },
      { label: "Arizona", value: "Arizona" },
      { label: "Arkansas", value: "Arkansas" },
      { label: "Armagh", value: "Armagh" },
      { label: "Arunachal Pradesh", value: "Arunachal Pradesh" },
      { label: "Assam", value: "Assam" },
      { label: "Auckland", value: "Auckland" },
      { label: "Ausser-Rhoden", value: "Ausser-Rhoden" },
      { label: "Aust Capital Terr", value: "Aust Capital Terr" },
      { label: "Ayrshire", value: "Ayrshire" },
      { label: "Banffshire", value: "Banffshire" },
      { label: "Bangkok", value: "Bangkok" },
      { label: "Basel-Land", value: "Basel-Land" },
      { label: "Basel-Stadt", value: "Basel-Stadt" },
      { label: "Bath&NthEstSomerset", value: "Bath&NthEstSomerset" },
      { label: "Bay of Plenty", value: "Bay of Plenty" },
      { label: "Bedfordshire", value: "Bedfordshire" },
      { label: "Berkshire", value: "Berkshire" },
      { label: "Berlin", value: "Berlin" },
      { label: "Bern", value: "Bern" },
      { label: "Berwickshire", value: "Berwickshire" },
      { label: "Bihar", value: "Bihar" },
      { label: "Brecknockshire", value: "Brecknockshire" },
      { label: "British Columbia", value: "British Columbia" },
      { label: "Buckinghamshire", value: "Buckinghamshire" },
      { label: "Buriram", value: "Buriram" },
      { label: "Buteshire", value: "Buteshire" },
      { label: "Caernarfonshire", value: "Caernarfonshire" },
      { label: "Caithness", value: "Caithness" },
      { label: "California", value: "California" },
      { label: "Cambridgeshire", value: "Cambridgeshire" },
      { label: "Canterbury", value: "Canterbury" },
      { label: "Cardiganshire", value: "Cardiganshire" },
      { label: "Carlow", value: "Carlow" },
      { label: "Carmarthenshire", value: "Carmarthenshire" },
      { label: "Cavan", value: "Cavan" },
      { label: "Chachoengsao", value: "Chachoengsao" },
      { label: "Chai Nat", value: "Chai Nat" },
      { label: "Chaiyaphum", value: "Chaiyaphum" },
      { label: "Chandigarh", value: "Chandigarh" },
      { label: "Chanthaburi", value: "Chanthaburi" },
      { label: "Cheshire", value: "Cheshire" },
      { label: "Chhaattisgarh", value: "Chhaattisgarh" },
      { label: "Chiang Mai", value: "Chiang Mai" },
      { label: "Chiang Rai", value: "Chiang Rai" },
      { label: "Chiba", value: "Chiba" },
      { label: "Chon Buri", value: "Chon Buri" },
      { label: "Chumphon", value: "Chumphon" },
      { label: "Clackmannanshire", value: "Clackmannanshire" },
      { label: "Clare", value: "Clare" },
      { label: "Colorado", value: "Colorado" },
      { label: "Connecticut", value: "Connecticut" },
      { label: "Cork", value: "Cork" },
      { label: "Cornwall", value: "Cornwall" },
      { label: "Cromartyshire", value: "Cromartyshire" },
      { label: "Cumberland", value: "Cumberland" },
      { label: "Dadra and Nagar Hav.", value: "Dadra and Nagar Hav." },
      { label: "Daman und Diu", value: "Daman und Diu" },
      { label: "Delaware", value: "Delaware" },
      { label: "Delhi", value: "Delhi" },
      { label: "Denbighshire", value: "Denbighshire" },
      { label: "Derbyshire", value: "Derbyshire" },
      { label: "Devon", value: "Devon" },
      { label: "District of Columbia", value: "District of Columbia" },
      { label: "Doha", value: "Doha" },
      { label: "Donegal", value: "Donegal" },
      { label: "Dorset", value: "Dorset" },
      { label: "Down", value: "Down" },
      { label: "Dubai", value: "Dubai" },
      { label: "Dublin", value: "Dublin" },
      { label: "Dumfriesshire", value: "Dumfriesshire" },
      { label: "Dunbartonshire", value: "Dunbartonshire" },
      { label: "Durham", value: "Durham" },
      { label: "Eastern Cape", value: "Eastern Cape" },
      { label: "East Lothian", value: "East Lothian" },
      { label: "East Sussex", value: "East Sussex" },
      { label: "Ehime", value: "Ehime" },
      { label: "Eldoret", value: "Eldoret" },
      { label: "Embu", value: "Embu" },
      { label: "Essex", value: "Essex" },
      { label: "Fermanagh", value: "Fermanagh" },
      { label: "Fife", value: "Fife" },
      { label: "Flintshire", value: "Flintshire" },
      { label: "Florida", value: "Florida" },
      { label: "Freestate", value: "Freestate" },
      { label: "Fribourg", value: "Fribourg" },
      { label: "Fujairah", value: "Fujairah" },
      { label: "Fukui", value: "Fukui" },
      { label: "Fukuoka", value: "Fukuoka" },
      { label: "Fukushima", value: "Fukushima" },
      { label: "Galway", value: "Galway" },
      { label: "Gauteng", value: "Gauteng" },
      { label: "Geneva", value: "Geneva" },
      { label: "Georgia", value: "Georgia" },
    ],
    marital_status: [
      { label: "Widow", value: "Widow" },
      { label: "Divorcee", value: "Divorcee" },
      { label: "Sep.", value: "Sep." },
      { label: "Widower", value: "Widower" },
      { label: "Single", value: "Single" },
      { label: "Married", value: "Married" },
      { label: "Not Given", value: "Not Given" },
    ],
    purpose_of_purchase: [
      { label: "Self Use", value: "Self Use" },
      { label: "For Kid’s Family", value: "For Kid’s Family" },
      { label: "Weekend Home", value: "Weekend Home" },
      { label: "Just Another Home", value: "Just Another Home" },
      { label: "Retirement Home", value: "Retirement Home" },
      { label: "Investment", value: "Investment" },
      { label: "For Rental Income", value: "For Rental Income" },
      { label: "N.A.", value: "N.A." },
    ],
    residential_status: [
      { label: "Non Resident Citizen", value: "Non Resident Citizen" },
      { label: "Resident Citizen", value: "Resident Citizen" },
      { label: "Foreigner", value: "Foreigner" },
      { label: "Outstation", value: "Outstation" },
    ],
    salutation: [
      { label: "Mr.", value: "Mr." },
      { label: "Ms.", value: "Ms." },
      { label: "Mrs.", value: "Mrs." },
      { label: "Dr.", value: "Dr." },
      { label: "Prof.", value: "Prof." },
      { label: "M/s", value: "M/s" },
      { label: "Trust", value: "Trust" },
      { label: "Commodore", value: "Commodore" },
      { label: "Captain", value: "Captain" },
      { label: "HUF", value: "HUF" },
    ],
    total_family_size: [
      { label: "1", value: "1" },
      { label: "2", value: "2" },
      { label: "3", value: "3" },
      { label: "4", value: "4" },
      { label: "5", value: "5" },
      { label: "6", value: "6" },
      { label: "7", value: "7" },
      { label: "8", value: "8" },
      { label: "9", value: "9" },
      { label: "10", value: "10" },
      { label: "N.A.", value: "N.A." },
    ],
    enquirySourceOptions: [
      { label: "99 Acres", value: "99 Acres", type: "Digital/Presales" },
      { label: "ACP", value: "ACP", type: "Channel Partner" },
      { label: "Anarock", value: "Anarock" },
      { label: "ATL", value: "ATL" },
      {
        label: "Bank Affiliates",
        value: "Bank Affiliates",
        type: "Loyalty/Corporate",
      },
      { label: "Chambers/Trade Bodies", value: "Chambers/Trade Bodies" },
      // { label: "Channel Partner", value: "Channel Partner" },
      { label: "Cinema", value: "Cinema" },
      { label: "Corporate", value: "Corporate" },
      { label: "Corporate activity", value: "Corporate activity" },
      {
        label: "Corporate Event",
        value: "Corporate Event",
        type: "Loyalty/Corporate",
      },
      { label: "Country Chambers", value: "Country Chambers" },
      { label: "Cross/OS CP", value: "Cross/OS CP", type: "Channel Partner" },
      { label: "Customer Expansion", value: "Customer Expansion" },
      {
        label: "Customer Referral",
        value: "Customer Referral",
        type: "Loyalty/Corporate",
      },
      {
        label: "Database Calling",
        value: "Database Calling",
        type: "Digital/Presales",
      },
      { label: "Database Outcalling", value: "Database Outcalling" },
      { label: "Digital", value: "Digital", type: "Digital/Presales" },
      { label: "Direct", value: "Direct" },
      { label: "Direct Reach Out (DRO)", value: "Direct Reach Out (DRO)" },
      { label: "Direct Walk-in", value: "Direct Walk-in" },
      { label: "Email", value: "Email", type: "Digital/Presales" },
      {
        label: "Employee Referral",
        value: "Employee Referral",
        type: "Loyalty/Corporate",
      },
      { label: "Events/Exhibitions", value: "Events/Exhibitions" },
      {
        label: "Existing Customer",
        value: "Existing Customer",
        type: "Loyalty/Corporate",
      },
      { label: "External Hoarding", value: "External Hoarding" },
      { label: "Facebook", value: "Facebook", type: "Digital/Presales" },
      {
        label: "Govt. Investment Promotion Board",
        value: "Govt. Investment Promotion Board",
      },
      {
        label: "Group Employee - International",
        value: "Group Employee - International",
      },
      { label: "Hoarding", value: "Hoarding", type: "Digital/Presales" },
      { label: "ICP", value: "ICP", type: "Channel Partner" },
      { label: "Industry Event", value: "Industry Event" },
      { label: "Internal Hoarding", value: "Internal Hoarding" },
      { label: "Local CP", value: "Local CP", type: "Channel Partner" },
      { label: "Loyalie", value: "Loyalie" },
      { label: "Magazines", value: "Magazines" },
      {
        label: "Mahindra Employee",
        value: "Mahindra Employee",
        type: "Loyalty/Corporate",
      },
      { label: "Marketing Partner", value: "Marketing Partner" },
      { label: "Metaverse", value: "Metaverse" },
      { label: "Mhada", value: "Mhada" },
      { label: "M-Life App", value: "M-Life App" },
      { label: "Newspaper", value: "Newspaper", type: "Digital/Presales" },
      { label: "NRI-CP", value: "NRI-CP", type: "Channel Partner" },
      { label: "NRI-Digital", value: "NRI-Digital", type: "NRI Sourcing" },
      {
        label: "NRI-Events/Roadshow",
        value: "NRI-Events/Roadshow",
        type: "NRI Sourcing",
      },
      { label: "NRI Local CP", value: "NRI Local CP", type: "Channel Partner" },
      { label: "NRI-Presales", value: "NRI-Presales", type: "NRI Sourcing" },
      { label: "NRI Referral", value: "NRI Referral", type: "NRI Sourcing" },
      {
        label: "NRI VDNB Referral",
        value: "NRI VDNB Referral",
        type: "NRI Sourcing",
      },
      { label: "Organic", value: "Organic", type: "Direct" },
      { label: "OS-Digital", value: "OS-Digital" },
      { label: "Others", value: "Others" },
      { label: "Outdoor", value: "Outdoor" },
      {
        label: "Outside Corporate",
        value: "Outside Corporate",
        type: "Loyalty/Corporate",
      },
      { label: "Presales", value: "Presales" },
      { label: "PresalesData", value: "PresalesData" },
      { label: "Print", value: "Print" },
      { label: "Property Consultant", value: "Property Consultant" },
      { label: "Radio", value: "Radio", type: "Digital/Presales" },
      { label: "Referral", value: "Referral" },
      { label: "Roadshow", value: "Roadshow" },
      { label: "SMS", value: "SMS", type: "Digital/Presales" },
      { label: "SMS-Digital", value: "SMS-Digital" },
      { label: "Support", value: "Support" },
      { label: "Television Advertising", value: "Television Advertising" },
      { label: "Trade Association", value: "Trade Association" },
      { label: "Train/Metro", value: "Train/Metro" },
      { label: "TV", value: "TV" },
      {
        label: "VDNB Referral",
        value: "VDNB Referral",
        type: "Digital/Presales",
      },
      { label: "VOIP", value: "VOIP" },
      { label: "Website", value: "Website", type: "Digital/Presales" },
      { label: "PreSales", value: "PreSales", type: "Digital/Presales" },
      {
        label: "Concurrent Referral",
        value: "Concurrent Referral",
        type: "Digital/Presales",
      },
      { label: "Word of Mouth", value: "Word of Mouth", type: "Direct" },
    ],
    enquiryTypeOptions: [
      { label: "Direct", value: "Direct" },
      { label: "Digital/Presales", value: "Digital/Presales" },
      { label: "NRI Sourcing", value: "NRI Sourcing" },
      // { label: "NRI", value: "NRI" },
      // { label: "Partner", value: "Partner" },
      // { label: "ACP", value: "ACP" },
      // { label: "Cross/ OS", value: "Cross/ OS" },
      { label: "Channel Partner", value: "Channel Partner" },
      // { label: "Presales", value: "Presales" },
      // { label: "Offline", value: "Offline" },
      { label: "Loyalty/Corporate", value: "Loyalty/Corporate" },
    ],
  },

  towers: [
    {
      tower_name: "Tower A",
      tower_value: "TowerA",
      total_appartment: "80",
      avalaible_apart: "65",
      floors: [
        {
          floor_number: 1,
          apartments: [
            {
              number: 101,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "800 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(5500000),
              all_inclusive_price: inrFormat(6000000),
            },
            {
              number: 102,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 103,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "700 Sqft.",
              facing: "South east facing",
              aggrement_value: inrFormat(5000000),
              all_inclusive_price: inrFormat(55000000),
            },
            {
              number: 104,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 105,
              status: "unavailable",
              configuration: "2BHK Spacia",
              aggregate_area: "1200 Sqft.",
              facing: "East facing",
              aggrement_value: inrFormat(9000000),
              all_inclusive_price: inrFormat(95000000),
            },
          ],
        },
        {
          floor_number: 2,
          apartments: [
            {
              number: 201,
              status: "available",
              configuration: "3BHK Spacia",
              aggregate_area: "1500 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(11000000),
              all_inclusive_price: inrFormat(12000000),
            },
            {
              number: 202,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "700 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(5000000),
              all_inclusive_price: inrFormat(6000000),
            },
            {
              number: 203,
              status: "unavailable",
              configuration: "2BHK Spacia",
              aggregate_area: "1100 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(8000000),
              all_inclusive_price: inrFormat(8500000),
            },
            {
              number: 204,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 205,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
          ],
        },
        {
          floor_number: 3,
          apartments: [
            {
              number: 301,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "1100 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(9000000),
              all_inclusive_price: inrFormat(9500000),
            },
            {
              number: 302,
              status: "available",
              configuration: "3BHK Spacia",
              aggregate_area: "1500 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(12000000),
              all_inclusive_price: inrFormat(12500000),
            },
            {
              number: 303,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 304,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 305,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
          ],
        },
        {
          floor_number: 4,
          apartments: [
            {
              number: 401,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 402,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 403,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "600 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(4500000),
              all_inclusive_price: inrFormat(4700000),
            },
            {
              number: 404,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 405,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7500000),
              all_inclusive_price: inrFormat(8000000),
            },
          ],
        },
        {
          floor_number: 5,
          apartments: [
            {
              number: 501,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "800 Sqft.",
              facing: "South facing",
              aggrement_value: inrFormat(6500000),
              all_inclusive_price: inrFormat(6700000),
            },
            {
              number: 502,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "400 Sqft.",
              facing: "West facing",
              aggrement_value: inrFormat(3500000),
              all_inclusive_price: inrFormat(3800000),
            },
            {
              number: 503,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 504,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 505,
              status: "available",
              configuration: "3BHK Spacia",
              aggregate_area: "1800 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(15000000),
              all_inclusive_price: inrFormat(15500000),
            },
          ],
        },
        {
          floor_number: 6,
          apartments: [
            {
              number: 601,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 602,
              status: "available",
              configuration: "3BHK Spacia",
              aggregate_area: "1300 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(9500000),
              all_inclusive_price: inrFormat(10000000),
            },
            {
              number: 603,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "450 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(4700000),
              all_inclusive_price: inrFormat(5000000),
            },
            {
              number: 604,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "450 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(4700000),
              all_inclusive_price: inrFormat(5000000),
            },
            {
              number: 605,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
          ],
        },
        {
          floor_number: 7,
          apartments: [
            {
              number: 701,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 702,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "600 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(4500000),
              all_inclusive_price: inrFormat(4700000),
            },
            {
              number: 703,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "1100 Sqft.",
              facing: "West facing",
              aggrement_value: inrFormat(9500000),
              all_inclusive_price: inrFormat(10000000),
            },
            {
              number: 704,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "800 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(6000000),
              all_inclusive_price: inrFormat(6500000),
            },
            {
              number: 705,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "450 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(5200000),
              all_inclusive_price: inrFormat(5500000),
            },
          ],
        },
        {
          floor_number: 8,
          apartments: [
            {
              number: 801,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 802,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 803,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 804,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 805,
              status: "unavailable",
              configuration: "3BHK Spacia",
              aggregate_area: "1600 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(11500000),
              all_inclusive_price: inrFormat(12000000),
            },
          ],
        },
        {
          floor_number: 9,
          apartments: [
            {
              number: 901,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 902,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 903,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 904,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 905,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "950 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(8000000),
              all_inclusive_price: inrFormat(9000000),
            },
          ],
        },
        {
          floor_number: 10,
          apartments: [
            {
              number: 1001,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1002,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1003,
              status: "available",
              configuration: "3BHK Spacia",
              aggregate_area: "1400 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(10000000),
              all_inclusive_price: inrFormat(11000000),
            },
            {
              number: 1004,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "1000 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(9000000),
              all_inclusive_price: inrFormat(9500000),
            },
            {
              number: 1005,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "1100 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(8500000),
              all_inclusive_price: inrFormat(9000000),
            },
          ],
        },

        {
          floor_number: 11,
          apartments: [
            {
              number: 1101,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "800 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(8000000),
              all_inclusive_price: inrFormat(8500000),
            },
            {
              number: 1102,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1103,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "400 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(3500000),
              all_inclusive_price: inrFormat(4000000),
            },
            {
              number: 1104,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1105,
              status: "available",
              configuration: "3BHK Spacia",
              aggregate_area: "1200 Sqft.",
              facing: "East facing",
              aggrement_value: inrFormat(1100000),
              all_inclusive_price: inrFormat(11500000),
            },
          ],
        },

        {
          floor_number: 12,
          apartments: [
            {
              number: 1201,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1202,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1203,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "400 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(3500000),
              all_inclusive_price: inrFormat(4000000),
            },
            {
              number: 1204,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1205,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "400 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(9000000),
              all_inclusive_price: inrFormat(9500000),
            },
          ],
        },
        {
          floor_number: 13,
          apartments: [
            {
              number: 1301,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "800 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(6500000),
              all_inclusive_price: inrFormat(7000000),
            },
            {
              number: 1302,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1303,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1304,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1305,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
          ],
        },
        {
          floor_number: 14,
          apartments: [
            {
              number: 1401,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1402,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1403,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1404,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "1200 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(10000000),
              all_inclusive_price: inrFormat(10500000),
            },
            {
              number: 1405,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
          ],
        },
        {
          floor_number: 15,
          apartments: [
            {
              number: 1501,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1502,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "700 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(5500000),
              all_inclusive_price: inrFormat(6000000),
            },
            {
              number: 1503,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1504,
              status: "available",
              configuration: "2BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "East facing",
              aggrement_value: inrFormat(8000000),
              all_inclusive_price: inrFormat(8500000),
            },
            {
              number: 1505,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
          ],
        },
        {
          floor_number: 16,
          apartments: [
            {
              number: 1601,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1602,
              status: "available",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1603,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1604,
              status: "unavailable",
              configuration: "1BHK Spacia",
              aggregate_area: "900 Sqft.",
              facing: "North east facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
            {
              number: 1605,
              status: "available",
              configuration: "3BHK Spacia",
              aggregate_area: "1400 Sqft.",
              facing: "North facing",
              aggrement_value: inrFormat(7000000),
              all_inclusive_price: inrFormat(75000000),
            },
          ],
        },
      ],
    },
    {
      tower_name: "Tower B",
      tower_value: "TowerB",
      total_appartment: "60",
      avalaible_apart: "50",
      floors: [
        {
          floor_number: 1,
          apartments: [
            { number: 101, status: "available" },
            { number: 102, status: "available" },
            { number: 103, status: "available" },
            { number: 104, status: "unavailable" },
            { number: 105, status: "unavailable" },
          ],
        },
        {
          floor_number: 2,
          apartments: [
            { number: 201, status: "available" },
            { number: 202, status: "available" },
            { number: 203, status: "unavailable" },
            { number: 204, status: "unavailable" },
            { number: 205, status: "unavailable" },
          ],
        },
        {
          floor_number: 3,
          apartments: [
            { number: 301, status: "available" },
            { number: 302, status: "available" },
            { number: 303, status: "unavailable" },
            { number: 304, status: "unavailable" },
            { number: 305, status: "unavailable" },
          ],
        },
        {
          floor_number: 4,
          apartments: [
            { number: 401, status: "available" },
            { number: 402, status: "available" },
            { number: 403, status: "unavailable" },
            { number: 404, status: "unavailable" },
            { number: 405, status: "unavailable" },
          ],
        },
        {
          floor_number: 5,
          apartments: [
            { number: 501, status: "available" },
            { number: 502, status: "available" },
            { number: 503, status: "unavailable" },
            { number: 504, status: "unavailable" },
            { number: 505, status: "unavailable" },
          ],
        },
        {
          floor_number: 6,
          apartments: [
            { number: 601, status: "available" },
            { number: 602, status: "available" },
            { number: 603, status: "unavailable" },
            { number: 604, status: "unavailable" },
            { number: 605, status: "unavailable" },
          ],
        },
        {
          floor_number: 7,
          apartments: [
            { number: 701, status: "available" },
            { number: 702, status: "available" },
            { number: 703, status: "unavailable" },
            { number: 704, status: "unavailable" },
            { number: 705, status: "unavailable" },
          ],
        },
        {
          floor_number: 8,
          apartments: [
            { number: 801, status: "available" },
            { number: 802, status: "available" },
            { number: 803, status: "unavailable" },
            { number: 804, status: "unavailable" },
            { number: 805, status: "unavailable" },
          ],
        },
        {
          floor_number: 9,
          apartments: [
            { number: 901, status: "available" },
            { number: 902, status: "available" },
            { number: 903, status: "unavailable" },
            { number: 904, status: "unavailable" },
            { number: 905, status: "unavailable" },
          ],
        },
        {
          floor_number: 10,
          apartments: [
            { number: 1001, status: "available" },
            { number: 1002, status: "available" },
            { number: 1003, status: "unavailable" },
            { number: 1004, status: "unavailable" },
            { number: 1005, status: "unavailable" },
          ],
        },

        {
          floor_number: 11,
          apartments: [
            { number: 1101, status: "available" },
            { number: 1102, status: "available" },
            { number: 1103, status: "unavailable" },
            { number: 1104, status: "unavailable" },
            { number: 1105, status: "unavailable" },
          ],
        },

        {
          floor_number: 12,
          apartments: [
            { number: 1201, status: "available" },
            { number: 1202, status: "available" },
            { number: 1203, status: "unavailable" },
            { number: 1204, status: "unavailable" },
            { number: 1205, status: "unavailable" },
          ],
        },
      ],
    },
    {
      tower_name: "Tower C",
      tower_value: "TowerC",
      total_appartment: "100",
      avalaible_apart: "75",
      roomsPerFloor: "8",
      floors: [
        {
          floor_number: 1,
          apartments: [
            { number: 101, status: "available" },
            { number: 102, status: "available" },
            { number: 103, status: "available" },
            { number: 104, status: "unavailable" },
            { number: 105, status: "unavailable" },
          ],
        },
        {
          floor_number: 2,
          apartments: [
            { number: 201, status: "available" },
            { number: 202, status: "available" },
            { number: 203, status: "unavailable" },
            { number: 204, status: "unavailable" },
            { number: 205, status: "unavailable" },
          ],
        },
        {
          floor_number: 3,
          apartments: [
            { number: 301, status: "available" },
            { number: 302, status: "available" },
            { number: 303, status: "available" },
            { number: 304, status: "available" },
            { number: 305, status: "available" },
          ],
        },
        {
          floor_number: 4,
          apartments: [
            { number: 401, status: "available" },
            { number: 402, status: "available" },
            { number: 403, status: "available" },
            { number: 404, status: "available" },
            { number: 405, status: "unavailable" },
          ],
        },
        {
          floor_number: 5,
          apartments: [
            { number: 501, status: "available" },
            { number: 502, status: "unavailable" },
            { number: 503, status: "available" },
            { number: 504, status: "available" },
            { number: 505, status: "available" },
          ],
        },
        {
          floor_number: 6,
          apartments: [
            { number: 601, status: "available" },
            { number: 602, status: "available" },
            { number: 603, status: "unavailable" },
            { number: 604, status: "available" },
            { number: 605, status: "available" },
          ],
        },
        {
          floor_number: 7,
          apartments: [
            { number: 701, status: "available" },
            { number: 702, status: "available" },
            { number: 703, status: "available" },
            { number: 704, status: "available" },
            { number: 705, status: "available" },
          ],
        },
        {
          floor_number: 8,
          apartments: [
            { number: 801, status: "available" },
            { number: 802, status: "available" },
            { number: 803, status: "available" },
            { number: 804, status: "available" },
            { number: 805, status: "available" },
          ],
        },
        {
          floor_number: 9,
          apartments: [
            { number: 901, status: "available" },
            { number: 902, status: "available" },
            { number: 903, status: "available" },
            { number: 904, status: "unavailable" },
            { number: 905, status: "unavailable" },
          ],
        },
        {
          floor_number: 10,
          apartments: [
            { number: 1001, status: "available" },
            { number: 1002, status: "available" },
            { number: 1003, status: "available" },
            { number: 1004, status: "available" },
            { number: 1005, status: "available" },
          ],
        },

        {
          floor_number: 11,
          apartments: [
            { number: 1101, status: "available" },
            { number: 1102, status: "available" },
            { number: 1103, status: "available" },
            { number: 1104, status: "available" },
            { number: 1105, status: "available" },
          ],
        },
        {
          floor_number: 12,
          apartments: [
            { number: 1201, status: "unavailable" },
            { number: 1202, status: "available" },
            { number: 1203, status: "unavailable" },
            { number: 1204, status: "unavailable" },
            { number: 1205, status: "unavailable" },
          ],
        },
        {
          floor_number: 13,
          apartments: [
            { number: 1301, status: "available" },
            { number: 1302, status: "available" },
            { number: 1303, status: "unavailable" },
            { number: 1304, status: "unavailable" },
            { number: 1305, status: "available" },
          ],
        },
        {
          floor_number: 14,
          apartments: [
            { number: 1401, status: "available" },
            { number: 1402, status: "available" },
            { number: 1403, status: "unavailable" },
            { number: 1404, status: "available" },
            { number: 1405, status: "available" },
          ],
        },
        {
          floor_number: 15,
          apartments: [
            { number: 1501, status: "available" },
            { number: 1502, status: "available" },
            { number: 1503, status: "available" },
            { number: 1504, status: "available" },
            { number: 1505, status: "available" },
          ],
        },
        {
          floor_number: 16,
          apartments: [
            { number: 1601, status: "available" },
            { number: 1602, status: "available" },
            { number: 1603, status: "available" },
            { number: 1604, status: "available" },
            { number: 1605, status: "available" },
          ],
        },
        {
          floor_number: 17,
          apartments: [
            { number: 1701, status: "available" },
            { number: 1702, status: "available" },
            { number: 1703, status: "available" },
            { number: 1704, status: "available" },
            { number: 1705, status: "available" },
          ],
        },
        {
          floor_number: 18,
          apartments: [
            { number: 1801, status: "available" },
            { number: 1802, status: "available" },
            { number: 1803, status: "unavailable" },
            { number: 1804, status: "available" },
            { number: 1805, status: "available" },
          ],
        },
        {
          floor_number: 19,
          apartments: [
            { number: 1901, status: "unavailable" },
            { number: 1902, status: "available" },
            { number: 1903, status: "unavailable" },
            { number: 1904, status: "unavailable" },
            { number: 1905, status: "unavailable" },
          ],
        },
        {
          floor_number: 20,
          apartments: [
            { number: 2001, status: "available" },
            { number: 2002, status: "available" },
            { number: 2003, status: "unavailable" },
            { number: 2004, status: "unavailable" },
            { number: 2005, status: "available" },
          ],
        },
        {
          floor_number: 21,
          apartments: [
            { number: 2101, status: "available" },
            { number: 2102, status: "available" },
            { number: 2103, status: "available" },
            { number: 2104, status: "available" },
            { number: 2105, status: "available" },
          ],
        },
        {
          floor_number: 22,
          apartments: [
            { number: 2201, status: "available" },
            { number: 2202, status: "unavailable" },
            { number: 2203, status: "available" },
            { number: 2204, status: "available" },
            { number: 2205, status: "unavailable" },
          ],
        },
      ],
    },
    {
      tower_name: "Tower D",
      tower_value: "TowerD",
      total_appartment: "50",
      avalaible_apart: "30",
      roomsPerFloor: "7",
      floors: [
        {
          floor_number: 1,
          apartments: [
            { number: 101, status: "available" },
            { number: 102, status: "available" },
            { number: 103, status: "available" },
            { number: 104, status: "unavailable" },
            { number: 105, status: "unavailable" },
          ],
        },
        {
          floor_number: 2,
          apartments: [
            { number: 201, status: "available" },
            { number: 202, status: "available" },
            { number: 203, status: "unavailable" },
            { number: 204, status: "unavailable" },
            { number: 205, status: "unavailable" },
          ],
        },
        {
          floor_number: 3,
          apartments: [
            { number: 301, status: "available" },
            { number: 302, status: "available" },
            { number: 303, status: "unavailable" },
            { number: 304, status: "unavailable" },
            { number: 305, status: "unavailable" },
          ],
        },
        {
          floor_number: 4,
          apartments: [
            { number: 401, status: "available" },
            { number: 402, status: "available" },
            { number: 403, status: "unavailable" },
            { number: 404, status: "unavailable" },
            { number: 405, status: "unavailable" },
          ],
        },
        {
          floor_number: 5,
          apartments: [
            { number: 501, status: "available" },
            { number: 502, status: "available" },
            { number: 503, status: "unavailable" },
            { number: 504, status: "unavailable" },
            { number: 505, status: "unavailable" },
          ],
        },
        {
          floor_number: 6,
          apartments: [
            { number: 601, status: "available" },
            { number: 602, status: "available" },
            { number: 603, status: "unavailable" },
            { number: 604, status: "unavailable" },
            { number: 605, status: "unavailable" },
          ],
        },
        {
          floor_number: 7,
          apartments: [
            { number: 701, status: "available" },
            { number: 702, status: "available" },
            { number: 703, status: "unavailable" },
            { number: 704, status: "unavailable" },
            { number: 705, status: "unavailable" },
          ],
        },
        {
          floor_number: 8,
          apartments: [
            { number: 801, status: "available" },
            { number: 802, status: "available" },
            { number: 803, status: "unavailable" },
            { number: 804, status: "unavailable" },
            { number: 805, status: "unavailable" },
          ],
        },
        {
          floor_number: 9,
          apartments: [
            { number: 901, status: "available" },
            { number: 902, status: "available" },
            { number: 903, status: "unavailable" },
            { number: 904, status: "unavailable" },
            { number: 905, status: "unavailable" },
          ],
        },
        {
          floor_number: 10,
          apartments: [
            { number: 1001, status: "available" },
            { number: 1002, status: "available" },
            { number: 1003, status: "unavailable" },
            { number: 1004, status: "unavailable" },
            { number: 1005, status: "unavailable" },
          ],
        },

        {
          floor_number: 11,
          apartments: [
            { number: 1101, status: "available" },
            { number: 1102, status: "available" },
            { number: 1103, status: "unavailable" },
            { number: 1104, status: "unavailable" },
            { number: 1105, status: "unavailable" },
          ],
        },
        {
          floor_number: 12,
          apartments: [
            { number: 1201, status: "available" },
            { number: 1202, status: "available" },
            { number: 1203, status: "unavailable" },
            { number: 1204, status: "unavailable" },
            { number: 1205, status: "unavailable" },
          ],
        },
        {
          floor_number: 13,
          apartments: [
            { number: 1301, status: "available" },
            { number: 1302, status: "available" },
            { number: 1303, status: "unavailable" },
            { number: 1304, status: "unavailable" },
            { number: 1305, status: "unavailable" },
          ],
        },
        {
          floor_number: 14,
          apartments: [
            { number: 1401, status: "available" },
            { number: 1402, status: "available" },
            { number: 1403, status: "unavailable" },
            { number: 1404, status: "unavailable" },
            { number: 1405, status: "unavailable" },
          ],
        },
        {
          floor_number: 15,
          apartments: [
            { number: 1501, status: "available" },
            { number: 1502, status: "available" },
            { number: 1503, status: "unavailable" },
            { number: 1504, status: "unavailable" },
            { number: 1505, status: "unavailable" },
          ],
        },
        {
          floor_number: 16,
          apartments: [
            { number: 1601, status: "available" },
            { number: 1602, status: "available" },
            { number: 1603, status: "unavailable" },
            { number: 1604, status: "unavailable" },
            { number: 1605, status: "unavailable" },
          ],
        },
        {
          floor_number: 17,
          apartments: [
            { number: 1701, status: "available" },
            { number: 1702, status: "available" },
            { number: 1703, status: "available" },
            { number: 1704, status: "available" },
            { number: 1705, status: "available" },
          ],
        },
        {
          floor_number: 18,
          apartments: [
            { number: 1801, status: "available" },
            { number: 1802, status: "available" },
            { number: 1803, status: "unavailable" },
            { number: 1804, status: "available" },
            { number: 1805, status: "available" },
          ],
        },
        {
          floor_number: 19,
          apartments: [
            { number: 1901, status: "unavailable" },
            { number: 1902, status: "available" },
            { number: 1903, status: "unavailable" },
            { number: 1904, status: "unavailable" },
            { number: 1905, status: "unavailable" },
          ],
        },
        {
          floor_number: 20,
          apartments: [
            { number: 2001, status: "available" },
            { number: 2002, status: "available" },
            { number: 2003, status: "unavailable" },
            { number: 2004, status: "unavailable" },
            { number: 2005, status: "available" },
          ],
        },
      ],
    },
    {
      tower_name: "Tower E",
      tower_value: "TowerE",
      total_appartment: "80",
      avalaible_apart: "75",
      roomsPerFloor: "5",
      floors: [
        {
          floor_number: 1,
          apartments: [
            { number: 101, status: "available" },
            { number: 102, status: "available" },
            { number: 103, status: "available" },
            { number: 104, status: "available" },
            { number: 105, status: "available" },
          ],
        },
        {
          floor_number: 2,
          apartments: [
            { number: 201, status: "available" },
            { number: 202, status: "available" },
            { number: 203, status: "unavailable" },
            { number: 204, status: "unavailable" },
            { number: 205, status: "unavailable" },
          ],
        },
        {
          floor_number: 3,
          apartments: [
            { number: 301, status: "available" },
            { number: 302, status: "available" },
            { number: 303, status: "available" },
            { number: 304, status: "available" },
            { number: 305, status: "unavailable" },
          ],
        },
        {
          floor_number: 4,
          apartments: [
            { number: 401, status: "unavailable" },
            { number: 402, status: "available" },
            { number: 403, status: "available" },
            { number: 404, status: "available" },
            { number: 405, status: "unavailable" },
          ],
        },
        {
          floor_number: 5,
          apartments: [
            { number: 501, status: "available" },
            { number: 502, status: "available" },
            { number: 503, status: "available" },
            { number: 504, status: "available" },
            { number: 505, status: "available" },
          ],
        },
        {
          floor_number: 6,
          apartments: [
            { number: 601, status: "available" },
            { number: 602, status: "available" },
            { number: 603, status: "available" },
            { number: 604, status: "available" },
            { number: 605, status: "unavailable" },
          ],
        },
        {
          floor_number: 7,
          apartments: [
            { number: 701, status: "unavailable" },
            { number: 702, status: "available" },
            { number: 703, status: "available" },
            { number: 704, status: "available" },
            { number: 705, status: "available" },
          ],
        },
        {
          floor_number: 8,
          apartments: [
            { number: 801, status: "available" },
            { number: 802, status: "unavailable" },
            { number: 803, status: "available" },
            { number: 804, status: "available" },
            { number: 805, status: "unavailable" },
          ],
        },
        {
          floor_number: 9,
          apartments: [
            { number: 901, status: "available" },
            { number: 902, status: "available" },
            { number: 903, status: "available" },
            { number: 904, status: "available" },
            { number: 905, status: "available" },
          ],
        },
        {
          floor_number: 10,
          apartments: [
            { number: 1001, status: "available" },
            { number: 1002, status: "available" },
            { number: 1003, status: "available" },
            { number: 1004, status: "available" },
            { number: 1005, status: "available" },
          ],
        },

        {
          floor_number: 11,
          apartments: [
            { number: 1101, status: "available" },
            { number: 1102, status: "unavailable" },
            { number: 1103, status: "available" },
            { number: 1104, status: "available" },
            { number: 1105, status: "available" },
          ],
        },
        {
          floor_number: 12,
          apartments: [
            { number: 1201, status: "available" },
            { number: 1202, status: "available" },
            { number: 1203, status: "available" },
            { number: 1204, status: "available" },
            { number: 1205, status: "available" },
          ],
        },
        {
          floor_number: 13,
          apartments: [
            { number: 1301, status: "unavailable" },
            { number: 1302, status: "available" },
            { number: 1303, status: "available" },
            { number: 1304, status: "available" },
            { number: 1305, status: "available" },
          ],
        },
        {
          floor_number: 14,
          apartments: [
            { number: 1401, status: "available" },
            { number: 1402, status: "available" },
            { number: 1403, status: "available" },
            { number: 1404, status: "available" },
            { number: 1405, status: "available" },
          ],
        },
        {
          floor_number: 15,
          apartments: [
            { number: 1501, status: "available" },
            { number: 1502, status: "available" },
            { number: 1503, status: "available" },
            { number: 1504, status: "available" },
            { number: 1505, status: "available" },
          ],
        },
        {
          floor_number: 16,
          apartments: [
            { number: 1601, status: "available" },
            { number: 1602, status: "available" },
            { number: 1603, status: "available" },
            { number: 1604, status: "unavailable" },
            { number: 1605, status: "available" },
          ],
        },
        {
          floor_number: 17,
          apartments: [
            { number: 1701, status: "available" },
            { number: 1702, status: "available" },
            { number: 1703, status: "available" },
            { number: 1704, status: "available" },
            { number: 1705, status: "available" },
          ],
        },
        {
          floor_number: 18,
          apartments: [
            { number: 1801, status: "available" },
            { number: 1802, status: "available" },
            { number: 1803, status: "unavailable" },
            { number: 1804, status: "available" },
            { number: 1805, status: "available" },
          ],
        },
        {
          floor_number: 19,
          apartments: [
            { number: 1901, status: "unavailable" },
            { number: 1902, status: "available" },
            { number: 1903, status: "unavailable" },
            { number: 1904, status: "unavailable" },
            { number: 1905, status: "unavailable" },
          ],
        },
        {
          floor_number: 20,
          apartments: [
            { number: 2001, status: "available" },
            { number: 2002, status: "available" },
            { number: 2003, status: "unavailable" },
            { number: 2004, status: "unavailable" },
            { number: 2005, status: "available" },
          ],
        },
        {
          floor_number: 21,
          apartments: [
            { number: 2101, status: "available" },
            { number: 2102, status: "available" },
            { number: 2103, status: "available" },
            { number: 2104, status: "available" },
            { number: 2105, status: "available" },
          ],
        },
        {
          floor_number: 22,
          apartments: [
            { number: 2201, status: "available" },
            { number: 2202, status: "unavailable" },
            { number: 2203, status: "available" },
            { number: 2204, status: "available" },
            { number: 2205, status: "unavailable" },
          ],
        },
        {
          floor_number: 23,
          apartments: [
            { number: 2301, status: "available" },
            { number: 2302, status: "unavailable" },
            { number: 2303, status: "available" },
            { number: 2304, status: "available" },
            { number: 2305, status: "unavailable" },
          ],
        },
        {
          floor_number: 24,
          apartments: [
            { number: 2401, status: "available" },
            { number: 2402, status: "unavailable" },
            { number: 2403, status: "available" },
            { number: 2404, status: "available" },
            { number: 2405, status: "unavailable" },
          ],
        },
        {
          floor_number: 25,
          apartments: [
            { number: 2501, status: "available" },
            { number: 2502, status: "unavailable" },
            { number: 2503, status: "available" },
            { number: 2504, status: "available" },
            { number: 2505, status: "unavailable" },
          ],
        },
      ],
    },
  ],

  customerTypes: [
    { label: "Individual", value: 2 },
    { label: "Private Limited Company", value: 3 },
    { label: "Partnership Firm", value: 4 },
    { label: "HUF firm", value: 5 },
  ],

  // towers_data:{
  //   tower_name:"Tower A",
  //   tower_value:"TowerA",

  // }
};

export { commonData };
